module.exports = __webpack_public_path__ + "img/download-arrow.a78780bd.svg";